export const LEGACY_MIGRATION_DISMISS_DURATION_MS = 24 * 60 * 60 * 1000;

export const LEGACY_MIGRATION_COPY = {
  topbarMessage: "Your workspace is moving to Text — see what's waiting for you.",
  primaryAction: 'Go to Text',
} as const;

export const LEGACY_MIGRATION_MODAL_COPY = {
  title: 'Your AI Agent is waiting',
  description: 'Point it to your website and start turning conversations into revenue.',
  primaryAction: 'Test your AI Agent',
  secondaryAction: 'Remind me later',
} as const;

export enum LegacyMigrationEvent {
  ModalDisplayed = 'Migration Info Modal Displayed',
  ModalDismissed = 'Migration Info Modal Dismissed',
  ModalRemindMeLaterClicked = 'Migration Info Modal Remind Me Later Clicked',
  ModalPrimaryActionClicked = 'Migration Info Modal Primary Action Clicked',
  TopbarDisplayed = 'Migration Info Alert Displayed',
  TopbarDismissed = 'Migration Info Alert Dismissed',
  TopbarCtaClicked = 'Migration Info Alert Cta Clicked',
}

export const LEGACY_MIGRATION_MODAL_ASSETS = {
  light: 'https://cdn.static-text.com/assets/text-app/migration-modal/migration_light.png',
  dark: 'https://cdn.static-text.com/assets/text-app/migration-modal/migration_dark.png',
} as const;
